import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  employeeLevel: {},
  statusCreateEmployeeLevel: null,
  statusUpdateEmployeeLevel: null,
  statusDeleteEmployeeLevel: null
};

export const getters = {
  employeeLevel: state => state.employeeLevel,
  statusCreateEmployeeLevel: state => state.statusCreateEmployeeLevel,
  statusUpdateEmployeeLevel: state => state.statusUpdateEmployeeLevel,
  statusDeleteEmployeeLevel: state => state.statusDeleteEmployeeLevel
};

export const mutations = {
  [types.EMPLOYEE_LEVEL.LIST_EMPLOYEE_LEVEL](state, data) {
    state.employeeLevel = data;
  },
  [types.EMPLOYEE_LEVEL.CREATE_EMPLOYEE_LEVEL](state, data) {
    state.statusCreateEmployeeLevel = data;
  }
};

export const actions = {
  async listEmployeeLevel({ commit }) {
    const response = await axios.get(api.LIST_EMPLOYEE_LEVEL);
    commit(types.EMPLOYEE_LEVEL.LIST_EMPLOYEE_LEVEL, response.data);
  },
  async createEmployeeLevel({ commit }, params) {
    const response = await axios.post(api.CREATE_EMPLOYEE_LEVEL, params);
    commit(types.EMPLOYEE_LEVEL.CREATE_EMPLOYEE_LEVEL, response.status);
  },
  // eslint-disable-next-line
  async updateEmployeeLevel({ commit }, params) {
    let url = `${api.UPDATE_EMPLOYEE_LEVEL}/${params.id}`;
    await axios.post(url, params.data);
  },
  // eslint-disable-next-line
  async deleteEmployeeLevel({ commit }, employeeLevelId) {
    await axios.delete(api.DELETE_EMPLOYEE_LEVEL + "/" + employeeLevelId);
  }
};
